module.exports = __webpack_public_path__ + "img/new_pointXXX1.9c3cbabf.png";